/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

// UI
export const SET_LOADING = 'SET_LOADING';
export const SET_SAVING = 'SET_SAVING';
export const SET_JIRA_ENABLED = 'SET_JIRA_ENABLED';
export const SET_SERVICENOW_ENABLED = 'SET_SERVICENOW_ENABLED';
export const SET_STORAGE_INTEGRATION_ENABLED = 'SET_STORAGE_INTEGRATION_ENABLED';
export const SET_REQUEST_MAPPER = 'SET_REQUEST_MAPPER';
export const SET_TEMPLATE_ASSESSORS = 'SET_TEMPLATE_ASSESSORS';
export const SET_TEMPLATE_VERIFIERS = 'SET_TEMPLATE_VERIFIERS';
export const SET_FLAG_NEW_TICKETING = 'SET_FLAG_NEW_TICKETING';

// Editing audit
export const RESET_AUDIT = 'RESET_AUDIT';
export const SET_AUDIT = 'SET_AUDIT';
export const SET_AUDIT_ORIGINAL_STATE = 'SET_AUDIT_ORIGINAL_STATE';
export const SET_AUDIT_TITLE = 'SET_AUDIT_TITLE';
export const SET_AUDIT_MANAGERS = 'SET_AUDIT_MANAGERS';
export const SET_AUDIT_RELATED_PROGRAM = 'SET_AUDIT_RELATED_PROGRAM';
export const SET_AUDIT_START_DATE = 'SET_AUDIT_START_DATE';
export const SET_AUDIT_END_DATE = 'SET_AUDIT_END_DATE';
export const SET_AUDIT_REPORT_START_DATE = 'SET_AUDIT_REPORT_START_DATE';
export const SET_AUDIT_REPORT_END_DATE = 'SET_AUDIT_REPORT_END_DATE';
export const SET_AUDIT_TYPE = 'SET_AUDIT_TYPE';
export const SET_AUDIT_FIRM = 'SET_AUDIT_FIRM';
export const SET_AUDIT_AUDITORS = 'SET_AUDIT_AUDITORS';
export const SET_AUDIT_STORAGE = 'SET_AUDIT_STORAGE';

// Audit errors
export const SET_AUDIT_ERRORS = 'SET_AUDIT_ERRORS';
export const SET_AUDIT_ERROR = 'SET_AUDIT_ERROR';
export const CLEAR_AUDIT_ERROR = 'CLEAR_AUDIT_ERROR';

// JIRA
export const SET_JIRA_DATA = 'SET_JIRA_DATA';
export const SET_INITIAL_JIRA_DATA = 'SET_INITIAL_JIRA_DATA';
export const SET_JIRA_TITLE = 'SET_JIRA_TITLE';

// REMOTE REQUESTS (JIRA, SERVICENOW)
export const SET_REMOTE_REQUESTS = 'SET_REMOTE_REQUESTS';
export const SET_SYNC_EXTERNAL_COMMENTS = 'SET_SYNC_EXTERNAL_COMMENTS';
export const SET_SYNC_EXTERNAL_ATTACHMENTS = 'SET_SYNC_EXTERNAL_ATTACHMENTS';

// Assessment template
export const SET_PERFORMING_ASSESSMENT = 'SET_PERFORMING_ASSESSMENT';
export const SET_ASSESSORS = 'SET_ASSESSORS';
export const SET_VERIFIERS = 'SET_VERIFIERS';

// Storage integration
export const SET_STORAGE_INTEGRATION_DATA = 'SET_STORAGE_INTEGRATION_DATA';
